import React from 'react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const CategoryList = ({ item }) => {
  const itemData = item.node.data

  return (
    <li className='space-y-10'>
      <PrismicLink href={item.node.url}>
        <article className='relative isolate flex flex-col gap-4 lg:flex-row'>
          <div className='w-full'>
            <div className='group relative max-w-xl'>
              <h3 className='mt-3 text-lg font-semibold text-cyan-700 group-hover:text-blue-950'>
                <span className='absolute inset-0' />
                {itemData.page_title.text}
              </h3>
              {(itemData.start_date_and_time || itemData.start_date_and_time) && (
                <div>
                  <div>
                    <div className='flex gap-1'>
                      {itemData.start_date_formatted === itemData.end_date_formatted ? itemData.start_date_formatted : `${itemData.start_date_formatted} to ${itemData.end_date_formatted}`},
                      <div className='rounded-full text-cyan-700'>{itemData.date_fromnow_formatted}</div>
                    </div>
                    <div className='text-sm font-semibold'>
                      {itemData.start_time_formatted && itemData.start_time_formatted} - {itemData.end_time_formatted && itemData.end_time_formatted}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {itemData.page_image.url && (
            <div className='relative aspect-[16/9] sm:aspect-[2/1] lg:aspect-square lg:h-20 lg:w-20 lg:shrink-0'>
              <GatsbyImage className='absolute inset-0 h-full w-full rounded bg-stone-50 object-cover' image={getImage(itemData.page_image)} alt={itemData.page_image.alt || ''} />
            </div>
          )}
        </article>
      </PrismicLink>
    </li>
  )
}

export default CategoryList
